import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import { CONTENT_TYPES } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import NewTestForm from 'core/modules/components/forms/NewTestForm';

const DialogNewTest = ({
  t,
  open,
  onSuccess,
  onCancel,
  students,
  currentStudents,
  sections,
  isEditing,
  test,
  onSectionCreated,
  isPublisherMode,
  preSelectionType,
  setSelectedTemplate,
  isAutoevaluative,
  shouldShowPublishScore,
}) => {
  const [title, setTitle] = useState(t('lesson:New task'));
  const [buttonTextSuccess, setButtonTextSuccess] = useState(t('lesson:Create task'));

  useEffect(() => {
    if (preSelectionType === CONTENT_TYPES.VIDEOLESSON) {
      setTitle(t('lesson:New videolesson'));
      setButtonTextSuccess(t('lesson:Create videolesson'));
    }
    if (preSelectionType === CONTENT_TYPES.QUESTION) {
      setTitle(t('lesson:New task'));
      setButtonTextSuccess(t('lesson:Create task'));
    }
    if (preSelectionType === CONTENT_TYPES.TEST) {
      setTitle(t('lesson:New quizz'));
      setButtonTextSuccess(t('lesson:Create quizz'));
    }
  }, [preSelectionType]);

  return (
    <Dialog title={isEditing ? test.name : title} isOpen={open} className={'dialog-new-test'} onClose={onCancel} size="xl">
      <div className="dialog-new-test__content">
        <NewTestForm
          currentTest={test}
          currentStudents={currentStudents}
          isEditing={isEditing}
          sections={sections}
          students={students}
          onCancel={onCancel}
          onSuccess={onSuccess}
          onSectionCreated={onSectionCreated}
          isPublisherMode={isPublisherMode}
          preSelectionType={preSelectionType}
          setSelectedTemplate={setSelectedTemplate}
          buttonTextSuccess={buttonTextSuccess}
          isAutoevaluative={isAutoevaluative}
          shouldShowPublishScore={shouldShowPublishScore}
        />
      </div>
    </Dialog>
  );
};

DialogNewTest.propTypes = {
  t: PropTypes.func,
  open: PropTypes.bool,
  students: PropTypes.array,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  currentStudents: PropTypes.array,
  sections: PropTypes.array,
  isEditing: PropTypes.bool,
  test: PropTypes.object,
  onSectionCreated: PropTypes.func,
  isPublisherMode: PropTypes.bool,
  preSelectionType: PropTypes.string,
  setSelectedTemplate: PropTypes.func,
  isAutoevaluative: PropTypes.bool,
  shouldShowPublishScore: PropTypes.bool,
};

DialogNewTest.defaultProps = {
  open: false,
  students: [],
  currentStudents: [],
  sections: [],
  isEditing: false,
  test: {},
  isPublisherMode: false,
  preSelectionType: '',
  t: function () {},
  onSuccess: function () {},
  onCancel: function () {},
  onSectionCreated: function () {},
  setSelectedTemplate: function () {},
};

export default withTranslation(['lesson'])(DialogNewTest);
